












import {Component, Vue} from 'vue-property-decorator'
@Component
export default class ModalScheduledReport extends Vue {
  close() {
    this.$modal.close('ModalScheduledReport')
  }

  openEvent() {
    this.$emit('open')
  }

  closeEvent() {
    this.$emit('close')
  }
}
